// extracted by mini-css-extract-plugin
export default {"smallParagraph":"vtw9V_"};